import {DWComponent} from './dw/DWComponent'

window.addEventListener('load', () => {
    DWComponent.mount({}, window.document.body)
})
